export default function () {
  return {
    errors: {},
    customToolbar: [['bold', 'italic', 'underline'], [{ list: 'ordered' }, { list: 'bullet' }], ['image']],
    faq: {
      id: null,
      question: '',
      answer: '',
    },
  }
}
